export default __webpack_public_path__ + "static/media/steer.35907e96.svg";